<template>
  <div class="tab-pane fade active show" id="device-error-search" role="tabpanel"
    aria-labelledby="device-error-search-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-2">
          <span>風景區</span>
          <select class="form-control" v-model="selectScenicAreaId">
            <option value="-1">請選擇</option>
            <option v-for="(list, index) in scenicAreaList" :key="index" :value="list.id">{{ list.name }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <span>設備種類</span>
          <select class="form-control" v-model="selectDeviceType">
            <option value="-1">請選擇</option>
            <option v-for="(list, index) in deviceTypeList" :key="index" :value="list.enumType">{{ list.description }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <span>通報狀態</span>
          <select class="form-control" v-model="selectNotify">
            <option value="-1">全部</option>
            <option :value="true">已通報</option>
            <option :value="false">未通報</option>

          </select>
        </div>
        <!-- <div class="col-md-3">
          <span>事件種類(目前無效)</span>
          <select class="form-control" v-model="selectDeviceErrorType">
            <option value="-1">請選擇</option>
            <option v-for="(prop, key) in deviceErrorTypeEnum" :key="key" :value="prop.value">{{ prop.description }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
        </div> -->
        <div class="col-md-3">
          <span>資料開始時間</span>
          <datetime input-class="form-control" type="date" format="yyyy-MM-dd" :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1" :max-datetime="maxSelectTime" :auto="true" v-model="startTime">
          </datetime>
        </div>

        <div class="col-md-3">
          <span>資料結束時間</span>
          <datetime input-class="form-control" type="date" format="yyyy-MM-dd" :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1" :max-datetime="maxSelectTime" :auto="true" v-model="endTime">
          </datetime>
        </div>
        <div class="col-md-3 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryDeviceError"
            :disabled="isWaiting">
            <i class="fas fa-search"></i>查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="queryCSV"
            :disabled="isWaiting">
            <i class="fas fa-share"></i>匯出
          </button>
        </div>
      </form>
    </div>
    <h1 style="margin-top: 0px;">設備事件查詢</h1>
    <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
      <div class="col">
        <div class="card card-clean h-100">
          <div class="bd-example">
            <table id="deviceErrorSearchTable" :class="tableStyle">
              <thead :class="tableThStyle" class="table-dark">
                <tr>
                  <th scope="col">斷線時間</th>
                  <th scope="col">風景區</th>
                  <th scope="col">地點</th>
                  <th scope="col">設備ID</th>
                  <th scrope="col">設備IP</th>
                  <th scope="col">設備種類</th>
                  <th scope="col">設備名稱</th>
                  <th scope="col">事件種類</th>
                  <th scope="col">事件原因</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in devicesErrorList" :key="index" :class="tableCenterStyle">
                  <td>{{ item.happenTime }}</td>
                  <td>{{ item.scenicAreaName }}</td>
                  <td>{{ item.publicPlaceName }}</td>
                  <td>{{ item.deviceId }}</td>
                  <td>{{ item.ip }}</td>
                  <td>{{ getDeviceTypeName(item.deviceType) }}</td>
                  <td>{{ item.deviceName }}</td>
                  <td>{{ item.deviceErrorType }} <br>({{ item.isNotify? "已通報":"尚未通報" }})</td>
                  <td style="white-space:normal;">{{ item.reason }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import moment from 'moment';
import { mapState, mapGetters } from 'vuex'
import CONST from '../../utils/const'
import Utils from '../../utils/utils'
import { getDeviceErrorData } from '../../api/eastCoastDataApi/device/DeviceErrorApi'
import exportCSV from '../../utils/exportCSV'
export default {
  name: "Home",
  data() {
    return {
      Const: CONST,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,
      selectScenicAreaId: -1,
      // selectPublicPlaceId: -1,
      deviceTypeList: [],
      selectNotify: -1,
      selectDeviceType: -1,
      selectDeviceErrorType: -1,
      devicesErrorList: [],
      deviceErrorTypeEnum: CONST.DEVICE_ERROR_TYPE,
      startTime: moment().startOf('day').format(),
      endTime: moment().endOf('day').format(),
      isWaiting: false
    };
  },
  computed: {
    ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),
    maxSelectTime() {
      return moment()
        .startOf('m')
        .toISOString()
    },
  },
  methods: {
    initTable: function () {
      this.table = $("#deviceErrorSearchTable").DataTable({
        aoColumns: [
          ...new Array($("#deviceErrorSearchTable th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url :'/json/dataTableZHTW.json'
        },
        "pageLength": 25,
      });
    },
    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy()
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
    async queryDeviceError() {

      this.isWaiting = true;
      let condition = {
        "areaId": this.selectScenicAreaId == -1 ? null : this.selectScenicAreaId,
        "deviceType": this.selectDeviceType == -1 ? null : this.selectDeviceType,
        "isNotify": this.selectNotify == -1 ? null : this.selectNotify,
        "deviceStatus": this.selectDeviceErrorType, //保留條件，目前後端沒有用
        "stTime": moment(this.startTime).startOf("day").format(),
        "endTime": moment(this.endTime).endOf("day").format()
      }
      //debugger;
      let response = await getDeviceErrorData(condition)
      if (response.status) {
        this.devicesErrorList = response.data
        this.updateTable()
        console.log(this.devicesErrorList);
      }
      else {
        console.log('getDeviceErrorData fail');
      }
      this.isWaiting = false;
    },
    async queryCSV() {
      this.isWaiting = true
      if (Utils.isEmptyObject(this.devicesErrorList)) {
        alert('請先查詢再匯出')
        this.isWaiting = false
        return
      }

      const csvContent = [['斷線時間', '風景區', '地點', '設備ID', '設備種類', '設備名稱']]
      let vm = this
      this.devicesErrorList.forEach(item => {
        const row = []
        row.push(item.happenTime)
        row.push(item.scenicAreaName)
        row.push(item.publicPlaceName)
        row.push(item.deviceId)
        row.push(this.getDeviceTypeName(item.deviceType))
        row.push(item.deviceName)

        csvContent.push(row)
      })

      const fileName = `CSV_${moment(this.startTime).format('YYYY/MM/DD HH:mm')}_設備事件.csv`
      exportCSV.genCSVFile(csvContent, fileName)
      this.isWaiting = false
    },
    getscenicAreaIdFromName(name) {
      // device 沒有 scenicAreaId
      const target = this.scenicAreaList.find(area => {
        return area.name === name
      })

      return target ? target.id : ''
    },
    getDeviceTypeName: function (deviceType) {

      const foundObject = this.deviceTypeList.find(item => item.enumType === deviceType);

      if (foundObject) {
        return foundObject.description;
      }
      else {
        return 'UnknownType';
      }
    }
  },
  async mounted() {
    this.updateTable()
    await this.$store.dispatch('deviceApi/getDevcieType')
    this.deviceTypeList = this.$store.getters['deviceApi/getDeviceType']
  },
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td, tr > th{width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */
</style>
  